import React, { Fragment } from "react";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  Alert,
} from "@mui/material";

import ExcelUsersListReportTransactions from "views/Print/ExcelUsersListReportTransactions";

import {
  cardBodyStyle,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewExcelDownload(props) {
  const classes = useStyles();

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container spacing={1} className={classes.containerProfile}>
            <Grid item xs={12} sm={12}>
              <div className={classes.titleCardFilter}>Descargar excel</div>
              <div className={classes.lineBottom}></div>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              style={{ paddingTop: 50, fontWeight: 400 }}
            >
              {props.id.length === 0 && (
                <>
                  <Alert severity="error">
                    No hay registro de transacciones.
                  </Alert>{" "}
                  <br></br>
                </>
              )}
              {props.title}
            </Grid>
            <Grid item xs={12} md={12} style={{ paddingTop: 50 }}>
              <center>
                <ExcelUsersListReportTransactions
                  excelData={props.id}
                  fileName={`Exportar_excel_transacciones`}
                />
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
